import _ from "lodash"
import { Editor, Transforms, Text, Node, Range } from "slate"
import { ReactEditor } from "slate-react"
import Element from "./element"

// ========================================= //
//  Main component
// ========================================= //

const withInlineSearch = (editor) => {
  const type = "inline-search"
  const trigger = "//"

  const {
    isVoid,
    isInline,
    insertText,
    extended: { onUpArrow, onDownArrow },
  } = editor

  // ========================================= //
  // Register render logic
  // ========================================= //

  // // set the render element
  // const render = (props) => {
  //   console.log("inside props", props.leaf)
  //   return props.leaf[type] && Element
  // }
  // editor.plugins.leaves[type] = render

  // set the render element
  editor.plugins.elements[type] = Element

  // ========================================= //
  // Extend existing editor functions
  // ========================================= //

  editor.isInline = (element) => {
    return element.type === type ? true : isInline(element)
  }

  // editor.isVoid = (element) => {
  //   return element.type === type ? true : isVoid(element)
  // }

  editor.insertText = (character) => {
    // call default editor function
    insertText(character)

    if (shouldTrigger(character)) showSearch()
  }

  // editor.extended.onUpArrow = (event) => {
  //   if (!editor.extended.inlineSearch.active) onUpArrow()
  //   event.preventDefault()
  // }

  // editor.extended.inlineSearch = {}
  // editor.extended.onDownArrow = (event) => {
  //   if (!editor.extended.inlineSearch.active) onDownArrow()
  //   event.preventDefault()
  // }

  // ========================================= //
  // Add editor functions
  // ========================================= //

  editor.extended.inlineSearch = {}

  editor.extended.inlineSearch.setLink = (itemID, location) => {
    // empty text leaf (contains partial search term)
    const path = location.path
    console.log('select:', location);
    Transforms.delete(editor, path)
    // Transforms.setPoint(editor, path)
    const link = { itemID, expand: true }
    editor.extended.link.make(link)
  }

  editor.extended.inlineSearch.remove = (path) => {
    Transforms.removeNodes(editor, { at: path })
  }

  // ========================================= //
  //  Supporting functions
  // ========================================= //

  const shouldTrigger = (character) => {
    return character === "/" && editor.extended.getCurrentWord() === trigger
  }

  const showSearch = () => {
    // select the trigger pattern to replace e.g. "//"
    editor.extended.selectCurrentWord(true)
    // child node won't maintain focus unless it contains a space at the front and end
    const surroundingSpaces = "  "
    const mention = { type, children: [{ text: surroundingSpaces }] }
    Transforms.insertNodes(editor, mention, { select: true })
    // this will place the focus between the two spaces which will keep the search box from losing focus while typing
    Transforms.move(editor, { reverse: true })
  }

  // ========================================= //
  // Return extended editor
  // ========================================= //

  return editor
}

export default withInlineSearch
